import {createContext} from 'react'

export const UpdateHeaderContext = createContext({
    updateNotifications: "",
    setUpdateNotification: () => {
    },
  }
)